// El candado que el sistema activa solo. Vive en el checklist del paso 09 y se ve como sus tareas,
// pero SIN número: numerarlo le prometería al vendedor un trabajo que no tiene que hacer.
import type { ReactNode } from 'react';
import { Check, ShieldCheck } from 'lucide-react';
import { cn } from '@/lib/cn';

export interface LockStatusPanelProps {
    title: string;
    desc: string;
    /** El proveedor ya confirmó el candado. */
    done: boolean;
    children: ReactNode;
}

export function LockStatusPanel({ title, desc, done, children }: LockStatusPanelProps) {
    return (
        <section
            className={cn(
                'flex items-start gap-3 rounded-[10px] border-[1.5px] bg-card px-4 py-3.5 transition-colors',
                done ? 'border-success-soft-border bg-success-soft/50' : 'border-border',
            )}
        >
            <span
                className={cn(
                    'flex size-7 flex-none items-center justify-center rounded-full border-[1.5px]',
                    done
                        ? 'border-success bg-success text-success-foreground'
                        : 'border-border bg-muted text-foreground/70',
                )}
            >
                {done ? (
                    <Check className="size-3.5" strokeWidth={3} aria-hidden />
                ) : (
                    <ShieldCheck className="size-3.5" aria-hidden />
                )}
            </span>

            <div className="min-w-0 flex-1">
                <div className="flex items-start justify-between gap-3">
                    <div className="min-w-0">
                        <div className="text-[13.5px] font-semibold leading-[1.2]">{title}</div>
                        <div className="mt-0.5 text-[11.5px] leading-[1.4] text-muted-foreground">
                            {desc}
                        </div>
                    </div>
                    {/* «Automático» es lo que le dice al vendedor que no está esperando nada suyo. */}
                    <div
                        className={cn(
                            'flex-none text-[10.5px] font-semibold uppercase tracking-[0.04em]',
                            done ? 'text-success' : 'text-muted-foreground',
                        )}
                    >
                        {done ? 'Listo' : 'Automático'}
                    </div>
                </div>

                <div className="mt-3 border-t border-dashed border-border pt-3">{children}</div>
            </div>
        </section>
    );
}
